import { UserRole } from '@upstart/harmony/lib/constants';
import { get } from 'lodash';

const MenuItems = [
  {
    name: 'Set-up',
    getUrl: (dealerId) => `/dealer/${dealerId}`,
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.READ_ONLY_ADMIN,
      UserRole.DEALER_ADMIN,
      UserRole.LIMITED_DEALER_ADMIN,
    ],
  },
  {
    name: 'Pricing',
    getUrl: (dealerId) => `/${dealerId}/pricing`,
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.READ_ONLY_ADMIN,
      UserRole.DEALER_ADMIN,
      UserRole.LIMITED_DEALER_ADMIN,
    ],
  },
  {
    name: 'Protection Plans',
    getUrl: (dealerId) => `/${dealerId}/protection-plans`,
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.READ_ONLY_ADMIN,
      UserRole.DEALER_ADMIN,
      UserRole.LIMITED_DEALER_ADMIN,
    ],
  },
  {
    name: 'Accessories',
    getUrl: (dealerId) => `/${dealerId}/accessories`,
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.READ_ONLY_ADMIN,
      UserRole.DEALER_ADMIN,
      UserRole.LIMITED_DEALER_ADMIN,
    ],
  },
  {
    name: 'Appointments',
    getUrl: (dealerId) => `/${dealerId}/appointments`,
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.READ_ONLY_ADMIN,
      UserRole.DEALER_ADMIN,
      UserRole.LIMITED_DEALER_ADMIN,
    ],
  },
  {
    name: 'Users',
    getUrl: (dealerId) => `/${dealerId}/users`,
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.READ_ONLY_ADMIN,
      UserRole.DEALER_ADMIN,
      UserRole.LIMITED_DEALER_ADMIN,

      UserRole.ACCOUNT_MANAGER,
    ],
  },
  {
    name: 'Logins',
    getUrl: (dealerId) => `/${dealerId}/crmlogins`,
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.READ_ONLY_ADMIN,
      UserRole.DEALER_ADMIN,
      UserRole.LIMITED_DEALER_ADMIN,
    ],
  },
  {
    name: 'Forms',
    getUrl: (dealerId) => `/${dealerId}/forms`,
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.READ_ONLY_ADMIN,
      UserRole.DEALER_ADMIN,
      UserRole.LIMITED_DEALER_ADMIN,
    ],
  },
  {
    name: 'Online Form-Packs',
    getUrl: (dealerId) => `/${dealerId}/onlineFormPacks`,
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.READ_ONLY_ADMIN,
      UserRole.DEALER_ADMIN,
      UserRole.LIMITED_DEALER_ADMIN,
    ],
  },
  {
    name: 'Form-Packs',
    getUrl: (dealerId) => `/${dealerId}/formPacks`,
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.READ_ONLY_ADMIN,
      UserRole.DEALER_ADMIN,
      UserRole.LIMITED_DEALER_ADMIN,
    ],
  },
  {
    name: 'Flow',
    getUrl: (dealerId) => `/${dealerId}/flow`,
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.READ_ONLY_ADMIN,
      UserRole.DEALER_ADMIN,
      UserRole.LIMITED_DEALER_ADMIN,
    ],
  },
  {
    name: 'Audit',
    getUrl: (dealerId) => `/${dealerId}/revisions`,
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.READ_ONLY_ADMIN],
  },
  {
    name: 'Text',
    getUrl: (dealerId) => `/${dealerId}/text`,
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.READ_ONLY_ADMIN],
  },
  {
    name: 'Credit Application',
    getUrl: (dealerId) => `/${dealerId}/applicant-form`,
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.READ_ONLY_ADMIN],
  },
  {
    name: 'Outreach',
    getUrl: (dealerId) => `/${dealerId}/outreach`,
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.READ_ONLY_ADMIN,
      UserRole.DEALER_ADMIN,
      UserRole.LIMITED_DEALER_ADMIN,
    ],
  },
  {
    name: 'Instore',
    getUrl: (dealerId) => `/${dealerId}/instore-config`,
    roles: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.READ_ONLY_ADMIN,
      UserRole.DEALER_ADMIN,
      UserRole.LIMITED_DEALER_ADMIN,
    ],
  },
  {
    name: 'Command Center',
    getUrl: (dealerId) => `/${dealerId}/command-center`,
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.READ_ONLY_ADMIN],
  },
];

const hasAnyOfRole =
  (user) =>
  ({ roles }) => {
    const userRoles = get(user, 'roles', []);
    return userRoles.some((role) => roles.includes(role));
  };

export default (user) => MenuItems.filter(hasAnyOfRole(user));
